import { AuthRoute } from '@/src/routes/routes.components'
import { Navigate, type RouteObject } from 'react-router-dom'

export const fallbackRoute: RouteObject = {
  path: '*',
  element: (
    <AuthRoute>
      <Navigate to='/' />
    </AuthRoute>
  ),
}
